import React, { useCallback, useState } from 'react';
import { Badge, Tooltip } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLiveNotificationFeed } from '../../hooks/useLiveNotificationFeed';
import { workflowApi } from '../../utils/api';

/** فقط وقتی سوکت وصل نیست: polling پشتیبان روی API */
const POLL_INTERVAL_MS = 60_000;

const fetchPendingCount = () => workflowApi.getPendingApprovals({ page: 1, per_page: 1 });

/** پاسخ API و سوکت هر دو meta.total دارند */
const readTotal = (res) => {
  const meta = res?.meta || res?.data?.meta || {};
  if (meta.total != null) return Number(meta.total) || 0;
  const list = Array.isArray(res?.data)
    ? res.data
    : Array.isArray(res?.data?.data)
      ? res.data.data
      : [];
  return list.length;
};

/**
 * نشانگر تعداد موارد در انتظار تأیید در هدر.
 * تعداد به صورت زنده از karmadws می‌آید (subscribe-workflow-pending / رویداد workflow_pending)؛
 * فقط وقتی سوکت در دسترس نیست، API هر ۶۰ ثانیه poll می‌شود.
 */
const WorkflowPendingBadge = ({ isDarkMode = false }) => {
  const { isAuthenticated, token } = useAuth();
  const [count, setCount] = useState(0);

  const applyResponse = useCallback((res) => setCount(readTotal(res)), []);

  useLiveNotificationFeed({
    subscribeEvent: 'subscribe-workflow-pending',
    event: 'workflow_pending',
    fetchList: fetchPendingCount,
    onResponse: applyResponse,
    pollIntervalMs: POLL_INTERVAL_MS,
    enabled: Boolean(isAuthenticated && token),
    label: 'Workflow pending',
  });

  return (
    <Tooltip title="کارتابل تأییدات">
      <Link
        to="/workflow/inbox"
        className={`
          relative flex items-center justify-center w-10 h-10 rounded-lg transition-all
          ${isDarkMode
            ? 'text-gray-300 hover:bg-[rgba(13,136,126,0.14)] hover:text-white'
            : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}
        `}
        aria-label="کارتابل تأییدات"
      >
        <Badge count={count} overflowCount={99} size="small" offset={[-2, 2]}>
          <InboxOutlined className="text-lg" />
        </Badge>
      </Link>
    </Tooltip>
  );
};

export default WorkflowPendingBadge;
